import { AuthStorage } from "utils/auth-storage";
import { Layout, Menu } from "antd";
import {
  AppstoreOutlined,
  BarChartOutlined,
  DatabaseOutlined,
  EnvironmentOutlined,
  SwapOutlined,
  SettingOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  ShoppingCartOutlined,
} from "@ant-design/icons";
import React, { useState, useEffect, useMemo } from "react";
import { Link, useLocation, useParams, Outlet } from "react-router-dom";
import { WarehouseServices } from "apis/Services/WarehouseService";

const { Sider, Content } = Layout;

// Base tabs array (static data only)
const baseTabs = [
  {
    id: 1,
    text: "Dashboard",
    value: "warehouse-dashboard",
    path: "warehouse-dashboard",
    icon: <AppstoreOutlined />,
  },
  {
    id: 2,
    text: "Inventory",
    value: "warehouse-inventory",
    path: "warehouse-inventory",
    icon: <DatabaseOutlined />,
  },
  {
    id: 3,
    text: "Job Sites",
    value: "warehouse-job-sites",
    path: "warehouse-job-sites",
    icon: <EnvironmentOutlined />,
  },
  {
    id: 4,
    text: "Purchase Orders",
    value: "warehouse-purchased-orders",
    path: "warehouse-purchased-orders",
    icon: <ShoppingCartOutlined />,
  },
  {
    id: 5,
    text: "Transfers",
    value: "warehouse-transfers",
    path: "warehouse-transfers",
    icon: <SwapOutlined />,
  },
  {
    id: 6,
    text: "Reports",
    value: "warehouse-reports",
    path: "warehouse-reports",
    icon: <BarChartOutlined />,
  },
];

const WareHouse = () => {
  const location = useLocation();
  const { company_id, id } = useParams();

  const [activeKey, setActiveKey] = useState(baseTabs[0].value);
  const [collapsed, setCollapsed] = useState(false);
  const [accessLevel, setAccessLevel] = useState(null);
  const [requestedTransfers, setRequestedTransfers] = useState(null);

  function getTransferRequestsCount() {
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    let ReqObj = {
      company: company_id,
      code,
      loginEmail: email,
    };
    WarehouseServices.getTransferRequests(ReqObj)
      .then((res) => {
        setRequestedTransfers(res?.transfersHistory?.pending);
        console.log(res, "transfer requests!!");
      })
      .catch((err) => {
        console.log(err);
      });
    // .finally(() => setisLoading(false));
  }

  // 1. Fetch access level on mount
  useEffect(() => {
    getAccessLevel();
    getTransferRequestsCount();
  }, []);

  function getAccessLevel() {
    // setisLoading(true);
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    let ReqObj = {
      company: company_id,
      project: id,
      code,
      loginEmail: email,
    };
    WarehouseServices.inventoryPageAccessLevel(ReqObj)
      .then((res) => {
        // Ensure accessLevel is a number for comparison
        setAccessLevel(parseInt(res.accessLevel));
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // 2. Conditionally create the final tabs array inside the component
  // Use useMemo so this array is only recalculated when accessLevel changes
  const tabs = useMemo(() => {
    return [
      ...baseTabs,
      // Conditionally add the Settings tab
      ...(accessLevel > 1
        ? [
            {
              id: 7,
              text: "Settings",
              value: "warehouse-settings",
              path: "warehouse-settings",
              icon: <SettingOutlined />,
            },
          ]
        : []),
    ];
  }, [accessLevel]); // Dependency array includes accessLevel

  // 3. Update activeKey when location changes OR when tabs structure changes (due to accessLevel)
  useEffect(() => {
    const currentTab = tabs.find((t) => location.pathname.includes(t.path));
    if (currentTab) {
      setActiveKey(currentTab.value);
    } else if (tabs.length > 0) {
      // Fallback: set to the first tab if no match is found, but tabs are present
      setActiveKey(tabs[0].value);
    }
  }, [location.pathname, tabs]); // tabs is now a dependency

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/* Sidebar */}
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
        width={230}
        theme="light"
        style={{ background: "#fff" }}
        className=" shadow-sm"
      >
        <div className="d-flex justify-content-center py-3">
          {!collapsed ? (
            <MenuFoldOutlined
              onClick={() => setCollapsed(true)}
              style={{ fontSize: 18, cursor: "pointer" }}
            />
          ) : (
            <MenuUnfoldOutlined
              onClick={() => setCollapsed(false)}
              style={{ fontSize: 18, cursor: "pointer" }}
            />
          )}
        </div>

        <Menu
          mode="inline"
          theme="light"
          selectedKeys={[activeKey]}
          inlineCollapsed={collapsed}
        >
          {tabs.map((item) => (
            <Menu.Item
              key={item.value}
              icon={React.cloneElement(item.icon)}
              title={item.text}
            >
              <Link
                to={`/main/company/${company_id}/${item.path}`}
                style={{ textDecoration: "none" }}
              >
                {!collapsed && (
                  <div className="d-flex align-items-center justify-content-between">
                    <h6
                      className="p-0 m-0 fw-bold"
                      style={{ fontSize: "1rem" }}
                    >
                      {item.text}
                    </h6>

                    {/* Render Badge only for Transfers tab if there are requests */}
                    {item.value === "warehouse-transfers" &&
                      requestedTransfers?.length > 0 && (
                        <span
                          style={{
                            backgroundColor: "#1777FF",
                            color: "#ffffff",
                            borderRadius: "50%",
                            padding: "0",
                            // marginLeft: "6px",
                            fontSize: "10px",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            minWidth: "18px",
                            height: "18px",
                            fontWeight: "bold",
                            lineHeight: "1",
                          }}
                        >
                          {requestedTransfers.length}
                        </span>
                      )}
                  </div>
                )}
              </Link>
            </Menu.Item>
          ))}
        </Menu>
      </Sider>

      {/* Page Content */}
      <Layout>
        <Content style={{ padding: "15px", backgroundColor: "white" }}>
          <Outlet context={{ getTransferRequestsCount }} />
        </Content>
      </Layout>
    </Layout>
  );
};

export default WareHouse;
